<template lang="html">
  <div class="wrapper -home">


    <section class="intro-home column-start">


      <div class="contenedor-slider">


        <slick ref="slick" :options="slickOptions">


          <div class="slide -slide-1">

            <div class="texto container column-start">

              <div>


                <div class="container contenedor-logo">
                  <img src="/static/img/UFV-logo.png" alt="UFV">
                </div>


                <h1>
                  Protagoniza tu futuro
                  <img src="/static/img/protagoniza-futuro.svg" alt="Protagoniza tu futuro">
                </h1>

                <h2>Despierta, descubre, decide.</h2>
                <h2>Nosotros te acompañamos</h2>

                <p>Programa de Acompañamiento Universitario para el inicio de la carrera profesional</p>

              </div>


            </div>
          </div>

          <div class="slide -slide-2">

            <div class="texto container column-start">

              <div>


                <div class="container contenedor-logo">
                  <img src="/static/img/UFV-logo.png" alt="UFV">
                </div>

                <h1>
                  Prácticas x Proyectos
                  <img class="proyectos" src="/static/img/proyectosxproyectos.png" alt="Protagoniza tu futuro">
                </h1>

                <h2>Hablanos de tus proyectos.</h2>
                <h2>El mejor talento de la ufv te ayudará a desarrollarlos.</h2>


              </div>

              <!-- <router-link :to="$t('enlaces.orientacion')" class="btn -skull">Más información</router-link> -->

            </div>
          </div>


        </slick>


      </div>



      <div class="contenedor-botones container row-between">

        <router-link class="row-center" :to="$t('enlaces.alumnos')">Alumnos y alumni</router-link>
        <router-link class="row-center" to="/empresas">Empresas</router-link>
        <router-link class="row-center" :to="$t('enlaces.observatorio')">Observatorio de empleo</router-link>
        <router-link class="row-center" :to="$t('enlaces.orientacion')">Orientación</router-link>
        <router-link class="row-center" :to="$t('enlaces.internacional')">Internacional</router-link>
        <!-- <router-link class="row-center" :to="$t('enlaces.guia')">Guía</router-link> -->




      </div>

    </section>

    <destacados :position="'0'"></destacados>

    <section class="proyecto-formativo -video-home">
      <div class="container column-center">
        <h2 class="big-bold-title">EN CARRERAS PROFESIONALES TE AYUDAMOS A CONSTRUIR TU FUTURO DESDE EL INICIO</h2>
        <p>Infórmate sobre el proceso de prácticas con este vídeo.</p>

        <video class="video-home" poster="/static/img/jpa.jpg" controls>

          <source src="/static/img/video-home.mp4" type="video/mp4" />
        </video>
      </div>
    </section>
    <section class="conectados-home">


      <div class="container row-between ais">


        <img src="/static/img/imagen-conectados.svg" class="imagen-conectados" alt="Imagen Conectados">


        <div class="main-card">
          <img src="/static/img/flecha.svg" alt="Ver más" :show="showsecondarycard" @click="showsecondarycard = false">
          <p>¿Recuerdas tus primeros pasos profesionales? Seguro que sentiste algunos miedos, inseguridades o
            necesitaste orientación y acompañamiento. Tu trayectoria, experiencia y conocimientos son muy valiosos para
            quien ahora comienza.</p>
          <p>¿Quieres apoyar a los jóvenes talentos?</p>
          <div class="boton-redondo"></div>

          <router-link :to="$t('enlaces.conectados') + '/profesional'" class="btn -skull -white">Conecta</router-link>
        </div>

        <div class="secondary-card" :show="showsecondarycard" @click="showsecondarycard = !showsecondarycard">
          <img src="/static/img/flecha.svg" alt="Ver más" :show="!showsecondarycard">
          <p>Conocer en profundidad te ayuda a tomar decisiones. Si tienes dudas sobre un sector, industria, empresa. Te
            enfrentas a un proceso de selección y quieres información para prepararte bien... ante cualquier duda en las
            decisiones sobre tu carrera profesional, te ponemos en contacto con quien puede ayudarte.</p>
          <router-link :to="$t('enlaces.conectados') + '/alumno'" class="btn -skull -white">Conecta</router-link>
        </div>
      </div>

    </section>


    <section class="quienes-somos-home banner-home row-center">
      <div class="quienes-somos-front column-center">


        <div class="container">
          <div class="intro-equipo">
            <p>En Carreras Profesionales <strong>formamos, orientamos y acompañamos</strong> a alumnos y antiguos
              alumnos
              en el inicio de
              su carrera, con el objetivo de que se desarrollen y crezcan buscando la verdad y el bien en el ejercicio
              de
              su profesión</p>
            <router-link :to="$t('enlaces.equipo')" class="btn -skull">CONOCE AL EQUIPO</router-link>
          </div>
          <h2 class="light-big-title">Quiénes somos</h2>


        </div>

      </div>

    </section>

    <al-dia :position="0"></al-dia>

  </div>
</template>

<script lang="js">

import aldia from '@/components/view-parts/home/al-dia';

import Slick from 'vue-slick';

import destacados from '@/components/parts/destacados';

export default {
  name: 'home',
  data() {
    return {
      slickOptions: {
        slidesToShow: 1,
        dots: true,
        arrows: false,
        adaptiveHeight: true,
        autoplay: true,
        autoplaySpeed: 3000
      },
      showsecondarycard: false
    }
  },
  components: {
    'al-dia': aldia,
    'destacados': destacados,
    Slick
  },
  methods: {
    topersonas() {
      $('html,body').animate({ scrollTop: $(".contenedor-personas.responsive").offset().top - 100 }, 500, 'swing');
    }
  }
}
</script>


<style>

</style>




// WEBPACK FOOTER //
// src/components/views/home.vue